var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{attrs:{"href":_vm.urls.full,"target":"_blank","rel":"noopener"},on:{"click":_vm.openPrototypeLink}},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.url)+" ")]},{"url":_vm.url})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }